import React, { useCallback } from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import { graphql } from 'react-relay';
import UserStatsArticleList from './UserStatsArticleList';
import { createQueryRenderer } from '../../relay/createQueryRenderer';

const UserStats = props => {
	const {
		onToggleBlocked,
		query: { viewer },
		page,
		user: { name: userName, blocked, id },
		handleChangePage,
	} = props;

	const { canDelete, id: currentUserId } = viewer.me;
	const { totalCount } = viewer.articles;

	const onPageChange = useCallback(
		page => {
			handleChangePage(page);
		},
		[handleChangePage],
	);

	return (
		<div>
			<h3>
				{userName}: {totalCount}
			</h3>
			{canDelete && currentUserId !== id && (
				<RaisedButton
					labelColor={'#ffffff'}
					onClick={onToggleBlocked}
					backgroundColor={!blocked ? '#f50000' : '#46bc98'}
					label={blocked ? 'Разблокиовать' : 'Заблокировать'}
				/>
			)}
			<UserStatsArticleList viewer={viewer} page={page} totalPages={Math.ceil(totalCount / 15)} onPageChange={onPageChange} />
		</div>
	);
};

export const UserStatsContainer = props =>
	createQueryRenderer(UserStats, {
		query: graphql`
			query UserStats_Query($userId: ID!, $page: Int) {
				viewer {
					me {
						id
						canDelete
					}
					articles: articlesPaginate(pageSize: 15, page: $page, user: $userId) {
						totalCount
						articles {
							...ArticleListItem_article
						}
					}
				}
			}
		`,
		variables: {
			userId: props.userId,
			page: props.page,
		},
		props,
	})();



// WEBPACK FOOTER //
// src/components/stats/UserStats.js